export enum GetUrlParams {
  AssetCode = 'assetCode',
  AssetIds = 'assetIds',
  Dst = 'dst',
  AssetQrPrefix = 'assetQrPrefix',
  DuplicatedVersionId = 'duplicatedVersionId',
  EndDate = 'endDate',
  FormCategoryIds = 'formCategoryIds',
  OrderingDirection = 'ordering_direction',
  OrderingField = 'ordering_field',
  Page = 'page',
  PerPage = 'per_page',
  PeriodEnd = 'periodEnd',
  PeriodStart = 'periodStart',
  Priority = 'priority',
  Search = 'search',
  SiteAndArea = 'siteAndArea',
  SiteAreaCode = 'siteAreaCode',
  SiteAreaIds = 'siteAreaIds',
  SiteCode = 'siteCode',
  SiteIds = 'siteIds',
  Step = 'step',
  Tab = 'tab',
  Token = 'token',
  View = 'view',
}

export const PER_PAGE_KEY_DEFAULT = '10';
export const PER_PAGE_KEY_SITES = '9';

export const ORDERING_DIRECTION_ASC = 'asc';
export const ORDERING_DIRECTION_DESC = 'desc';
export const DEFAULT_ORDERING_DIRECTION = ORDERING_DIRECTION_DESC;

export const PAGINATION_PARAMS = {
  [GetUrlParams.Page]: '1',
  [GetUrlParams.PerPage]: PER_PAGE_KEY_DEFAULT,
  [GetUrlParams.OrderingField]: 'createdAt',
  [GetUrlParams.OrderingDirection]: ORDERING_DIRECTION_DESC,
};

export type OrderingParams = {
  [GetUrlParams.OrderingField]?: string;
  [GetUrlParams.OrderingDirection]?: string;
};

export type OrderingState = [OrderingParams, (v: OrderingParams) => void];

export type PaginationParams = {
  [GetUrlParams.Page]?: string | number;
  [GetUrlParams.PerPage]?: string | number;
};

export type PaginationState = [PaginationParams, (v: PaginationParams) => void];

export const DEFAULT_SEARCH_LIST_VARIABLES = {
  page: 1,
  limit: 20,
};

export const PATH_ADD = 'add';
export const PATH_APPROVALS = 'approvals';
export const PATH_AREAS = 'areas';
export const PATH_ASSETS = 'assets';
export const PATH_AUTH = 'auth';
export const PATH_CATEGORIES = 'categories';
export const PATH_CODE_OF_CONDUCT = 'code-of-conduct';
export const PATH_DASHBOARD = 'dashboard';
export const PATH_DUPLICATE = 'duplicate';
export const PATH_EDIT = 'edit';
export const PATH_FORM_TEMPLATES = 'form-templates';
export const PATH_ID = ':id';
export const PATH_LATEST_VERSION = 'latest_version';
export const PATH_OVERVIEW = 'overview';
export const PATH_PROFILE = 'profile';
export const PATH_SETUP = 'setup';
export const PATH_SITES = 'sites';
export const PATH_TASKS = 'tasks';
export const PATH_TIMELINE = 'timeline';
export const PATH_USERS = 'users';
export const PATH_VERSION_ID = ':versionId';
export const PATH_VIEW = 'view';
